module.exports = __webpack_public_path__ + "static/img/1.89146a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/1.png
// module id = u7bv
// module chunks = 0